import React, { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';
import { DashboardContext } from 'src/context/DashboardContext';

function Progress() {
  const [isActive, setIsActive] = useState(false);
  const [timer, setTimer] = useState(null);
  let isLoading = useSelector((state) => state.ui.loading);
  const context = useContext(DashboardContext);
  if (context !== null && context.loadingFile !== null) {
    isLoading = isLoading && !context.loadingFile;
  }

  useEffect(() => {
    if (isLoading) {
      if (!timer) {
        setTimer(setTimeout(() => {
          setTimer(null);
          setIsActive(isLoading);
        }, 250));
      }
    } else {
      setIsActive(false);
    }
    return function cleanup() {
      setTimer(null);
    };
  }, [isLoading]);

  return (isLoading && isActive ? <CircularProgress /> : '');
}

export default Progress;
